"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function NewSettingsGreyFilled(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16 6.636v1.82c-.096.103-.053.237-.076.357-.049.26-.175.39-.461.403-2.022.088-3.176 2.069-2.268 3.89.136.272.105.464-.134.652a8.3 8.3 0 01-2.163 1.23c-.275.106-.46.053-.63-.207-1.102-1.682-3.386-1.69-4.49-.014-.18.272-.371.319-.657.204a8.23 8.23 0 01-2.096-1.214c-.317-.254-.337-.344-.155-.716.366-.747.408-1.514.065-2.27-.46-1.012-1.28-1.53-2.375-1.606-.279-.02-.406-.137-.454-.408-.153-.852-.127-1.702-.01-2.554.035-.253.173-.374.442-.383 2.079-.066 3.212-2.23 2.278-3.914-.14-.255-.094-.446.133-.625C3.61.762 4.33.352 5.112.05c.283-.11.46-.036.626.218 1.099 1.672 3.39 1.67 4.496-.004.17-.257.352-.317.63-.204a8.35 8.35 0 011.98 1.114c.323.249.402.555.237.92-.732 1.619.305 3.508 2.049 3.734.444.058.72.315.825.772.004.016.03.026.045.037zm-4.003.882a3.995 3.995 0 00-3.935-4.001c-2.144-.036-4.088 1.735-4.05 4.102.033 2.048 1.751 3.942 4.03 3.91a3.997 3.997 0 003.954-4.012z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C6A6A",
    d: "M16 6.636v1.82c-.096.103-.053.237-.076.357-.049.26-.175.39-.461.403-2.022.088-3.176 2.069-2.268 3.89.136.272.105.464-.134.652a8.3 8.3 0 01-2.163 1.23c-.275.106-.46.053-.63-.207-1.102-1.682-3.386-1.69-4.49-.014-.18.272-.371.319-.657.204a8.23 8.23 0 01-2.096-1.214c-.317-.254-.337-.344-.155-.716.366-.747.408-1.514.065-2.27-.46-1.012-1.28-1.53-2.375-1.606-.279-.02-.406-.137-.454-.408-.153-.852-.127-1.702-.01-2.554.035-.253.173-.374.442-.383 2.079-.066 3.212-2.23 2.278-3.914-.14-.255-.094-.446.133-.625C3.61.762 4.33.352 5.112.05c.283-.11.46-.036.626.218 1.099 1.672 3.39 1.67 4.496-.004.17-.257.352-.317.63-.204a8.35 8.35 0 011.98 1.114c.323.249.402.555.237.92-.732 1.619.305 3.508 2.049 3.734.444.058.72.315.825.772.004.016.03.026.045.037zm-4.003.882a3.995 3.995 0 00-3.935-4.001c-2.144-.036-4.088 1.735-4.05 4.102.033 2.048 1.751 3.942 4.03 3.91a3.997 3.997 0 003.954-4.012z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.96 10.215c-1.48.041-2.696-1.314-2.66-2.737.038-1.486 1.196-2.67 2.687-2.67 1.602.002 2.63 1.2 2.665 2.313.063 1.956-.993 3.093-2.693 3.094z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C6A6A",
    d: "M7.96 10.215c-1.48.041-2.696-1.314-2.66-2.737.038-1.486 1.196-2.67 2.687-2.67 1.602.002 2.63 1.2 2.665 2.313.063 1.956-.993 3.093-2.693 3.094z"
  }));
}

NewSettingsGreyFilled.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
NewSettingsGreyFilled.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = NewSettingsGreyFilled;
exports["default"] = _default;